module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Book.e2f36b6c.otf";